import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { ListBlackListCSSStyleImpl } from './listblacklistcss';



export class ArabicListBlackListCSSStyleImpl extends ListBlackListCSSStyleImpl
{
    getWrapperCSSStyle():object
    {
        return{
            width: "100%",
           
            textAlign: "center"
        };
    }

    getCallerHeaderTitle():object
    {
        return{
            fontSize: this.getResources().getFont(Fonts.h16),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "80px",
            width: "100%",
            textAlign: "center",
        };
    }

    getCallerDescriptionDivCSSStyle():object
    {
        return{
            textAlign: "center",
            height:'auto',
            fontSize: this.getResources().getFont(Fonts.h12),
            color: '#6D6D6D',
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "40px",
            // height: "60px",
            width: "100%",
            marginTop: "20px",
            paddingLeft: "5%",
            paddingRight: "5%",
        };
    }

    getCreateButtonDivCSSStyle(width: string):object
    {
        return{
            width: width,
            minWidth:"95px",
            display: "inline-block",
            marginTop: "0px",
            margin: "0 !important",
            marginBottom:'0px',
        };
    }

    getListHeaderWrapperDivCSSStyle():object
    {
        return{
            width:'100%',height:'auto',display:'flex'
        };
    }

    getListTitleDivCSSStyle():object
    {
        return{
            width:'50%',textAlign:'right',height:'100%',marginLeft:'0%'
        };
    }

    getListLabelCSSStyle():object{
        return{
            width:'100%',height:'100%',marginBottom:'0px',fontSize:'30px',lineHeight:'40px',fontWeight:900
        };
    }

    getButtonDivCSSStyle():object
    {
        return{
            width:'50%',height:'100%',textAlign:'left',marginRight:'0%'
        };
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklisting/arabiclistblacklistcss.tsx